import React from 'react';

const NoteHeaderContent = ({ item, onClick }) => {
  const dateStr = new Date(item.createdate).toLocaleString();
  const pills = [];

  const isSOAP = /SOAP|S\.O\.A\.P\./i.test(item.text_only || '');
  if (isSOAP) {
    pills.push({ label: 'SOAP', color: '#3B4C66' });
  }

  const sortedTags = (item.tags || []).sort((a, b) => (a.priority || 99) - (b.priority || 99));
  sortedTags.forEach(tag => {
    pills.push({ label: tag.label_name, color: tag.color || '#ccc' });
  });

  return (
    <div className="note-header-content">
      <div className="note-date">{dateStr}</div>
      {pills.length > 0 && (
        <div className="note-pills">
          {pills.map((pill, index) => (
            <span
              key={index}
              className="pill"
              style={{ backgroundColor: pill.color }}
            >
              {pill.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default NoteHeaderContent;
